/**
 * Dashboard api for the takings page
 */

import Dashboard from "./dashboard";

export default class TakingsAPI extends Dashboard {
  constructor() {
    super();
  }

  encodeDataToURL = (params) => {
    let urlVals = Object.keys(params)
      .map((value) => `${value}=${encodeURIComponent(params[value])}`)
      .join("&");
    return urlVals;
  };

  /**
   * Load Takings via async job (avoids API Gateway ~29s timeout on large events).
   * Optional onProgress({ status, phase, elapsedSec }) for UI updates.
   */
  async getTotalSales(context, onProgress) {
    const accessToken = localStorage.getItem("accessToken");
    const accessUser = localStorage.getItem("accessUser");
    const query = {
      eventId: context.eventId,
      startTime: context.searchStartTime,
      endTime: context.searchEndTime,
      stallholders: context.searchStallholders,
      stalls: context.searchStalls,
    };

    const startedAt = Date.now();
    const notify = (status) => {
      if (typeof onProgress === "function") {
        onProgress({
          ...status,
          elapsedSec: Math.max(1, Math.round((Date.now() - startedAt) / 1000)),
        });
      }
    };

    const start = await this.api
      .post(
        "/components/takings/job?user=" +
          accessUser +
          "&accessToken=" +
          accessToken,
        { query }
      )
      .then((response) => response.data);

    const jobId = start && start.jobId;
    if (!jobId) {
      throw new Error("No takings job id returned");
    }

    notify({ status: start.status || "PENDING", phase: "queued", jobId });

    const maxAttempts = 150; // ~5 min at 2s
    for (let i = 0; i < maxAttempts; i++) {
      await new Promise((r) => setTimeout(r, 2000));
      const status = await this.api
        .get(
          "/components/takings/job?user=" +
            accessUser +
            "&accessToken=" +
            accessToken +
            "&jobId=" +
            encodeURIComponent(jobId)
        )
        .then((response) => response.data);

      notify({
        status: status.status,
        phase: status.phase,
        jobId,
        error: status.error,
      });

      if (status.status === "COMPLETE") {
        if (!status.result) {
          throw new Error("Takings job finished without result");
        }
        return status.result;
      }
      if (status.status === "FAILED") {
        throw new Error(status.error || "Takings job failed");
      }
      if (status.status === "CANCELLED") {
        throw new Error("Takings job cancelled");
      }
    }
    throw new Error("Takings job timed out — try again or narrow filters");
  }

  cancelTakingsJob(jobId) {
    const accessToken = localStorage.getItem("accessToken");
    const accessUser = localStorage.getItem("accessUser");
    return this.api
      .post(
        "/components/takings/job?user=" +
          accessUser +
          "&accessToken=" +
          accessToken,
        { action: "cancel", jobId }
      )
      .then((response) => response.data);
  }
}
